<template>
    <div class="content3d-area relative" style="z-index:2; overflow:hidden;">
        <div style="position:absolute; top:0; left:50%; width:40px; height:20px; margin-left:-20px;">
            <img :src="Arrow" />
        </div>

        <div class="b-container relative" style="padding-top:60px; padding-bottom:60px;">
            <div
                style="position:absolute; bottom:-310px; left:0; width:620px; height:620px; margin-left:-620px; opacity:.5;">
                <img :src="Circle" />
            </div>

            <div
                style="position:absolute; top:-160px; right:0; width:780px; height:780px; margin-right:-780px; opacity:.5;">
                <img :src="Circle" style="width:100%; height:100%;" />
            </div>

            <div class="column v-center center mb-xxl">
                <div class="row">
                    <div class="ml-xxl white h1">
                        硬件设施服务
                    </div>
                    <div class="relative ml-md" style="width:44px; height:44px;">
                        <img :src="PlusWhiteIcon" style="width:44px; height:44px; position:absolute; top:-12px; left:0;" />
                    </div>
                </div>
                <div class="white t3" style="text-transform: uppercase; letter-spacing:.1em; opacity:.5;">
                    Hardware facilities
                </div>
            </div>

            <!-- SWIPER START -->
            <div class="relative swiper-container-wrap mb-lg" id="content3d-swiper-wrap">
                <div v-show="paginationBulletsLength !== 1" class="swiper-prev column center v-start">
                    <img :src="IconPrev" style="display:block; width:28px; height:48px;" />
                </div>

                <div v-show="paginationBulletsLength !== 1" class="swiper-next column center v-end">
                    <img :src="IconNext" style="display:block; width:28px; height:48px;" />
                </div>

                <div class="swiper-container" id="content3d-swiper">
                    <div class="swiper-wrapper">
                        <div v-for="(item, index) in list" class="swiper-slide content3d-swiper-slide" :key="index">
                            <!-- <div
                                class="swiper-item column f1 v-center relative secondary-bg"
                                :class="{ hover: index == activeIndex }"
                                style="position:absolute; top:0; right:15px; bottom:0; left:15px;"
                                @mouseover="activeIndex = index"
                                @mouseout="activeIndex = -1"
                            > -->
                            <div class="swiper-item column f1 v-center relative secondary-bg hover"
                                style="position:absolute; top:0; right:15px; bottom:0; left:15px;"
                                @mouseover="activeIndex = index" @mouseout="activeIndex = -1">
                                <div style="position:absolute; width:100%; height: 100%; z-index:2;">
                                    <img :src="item.cover" class="card-photo" />
                                </div>
                                <div class="desc px-lg py-lg column">
                                    <div class="h4 mb-md">{{ item.name }}</div>
                                    <!-- <div
                                        v-show="index == activeIndex"
                                        class="t6"
                                        v-html="item.summary"
                                    ></div> -->
                                    <div class="t6" v-html="item.summary"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="paginationBulletsLength !== 1" class="mt-xxl row v-center center" style="height:16px;">
                        <div class="swiper-pagination222"></div>
                    </div>
                </div>
            </div>
            <!-- SWIPER END -->
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

import {
    IconPrev,
    IconNext,
    PlusWhiteIcon,
    Arrow,
    Circle,
    Hardware01,
    Hardware03,
    Hardware04,
    Hardware07,
} from '@/constants/pics';

export default {
    name: 'content3d',

    props: [],

    components: {},

    data() {
        return {
            swiper: null,

            IconPrev,
            IconNext,
            PlusWhiteIcon,

            Arrow,
            Circle,

            currentItem: 0,
            activeIndex: -1,

            list: [
                {
                    cover: Hardware01,
                    name: '视觉产品',
                    summary:
                        '帮助企业学校架构监控视频，门禁通行的集中管理平台。AI赋能监控设备，提供实际场景的算法服务。',
                },
                {
                    cover: Hardware03,
                    name: '显示产品',
                    summary:
                        '兼容无系统电视、安卓系统电视、数字标牌、拼接屏幕、电子班牌等多种设备。方便快捷的分类管理方式，帮助企业学校高效的发布信息和风采展。',
                },
                {
                    cover: Hardware04,
                    name: '音响灯光',
                    summary:
                        '音乐与灯光的完美结合，帮助终端用户达成更优效果的方案。',
                },
                {
                    cover: Hardware07,
                    name: '全国运维',
                    summary:
                        '7*24小时全天候服务，拥有在线及本地部署的两套服务体系，全国统一标准服务。',
                },
            ],
        };
    },

    computed: {
        paginationBulletsLength() {
            if (!this.swiper) {
                return 1;
            }

            return this.swiper.pagination.bullets.length;
        },
    },

    created() { },

    mounted() {
        this.$nextTick(function () {
            this.initSwiper();
        });

        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                    // this.$nextTick(function() {
                    //     this.initSwiper();
                    // });
                }, 300);
            }
        });
    },

    activated() { },

    deactivated() { },

    methods: {
        onArtistClick() {
            const id = 'test';

            this.$router.push({ path: '/artist' });
        },

        lightbox() {
            this.showLightbox = true;
        },

        close() {
            this.showLightbox = false;
        },

        initSwiper() {
            this.swiper = new Swiper('#content3d-swiper', {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 0,

                slidesPerView: 'auto',
                threshold: 10,

                initialSlide: +this.currentItem,
                observer: true,
                observeParents: true,

                navigation: {
                    nextEl: '#content3d-swiper-wrap .swiper-next',
                    prevEl: '#content3d-swiper-wrap .swiper-prev',
                },

                pagination: {
                    el: '.swiper-pagination222',
                    clickable: true,
                },

                breakpoints: {
                    // when window width is >= 480px
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    479: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    480: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 720px
                    719: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    720: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1279: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1280: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1392: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    5120: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        // spaceBetween: 24,
                    },
                },
            });

            if (this.swiper) {
                this.swiper.on(
                    'slideChange',
                    () => {
                        this.currentItem = this.swiper.activeIndex;
                    },
                );
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.content3d-area {
    background: linear-gradient(to right, rgba(255, 51, 85, 1) 0%, rgba(241, 53, 54, 1) 100%);
    overflow: hidden;
}

// swiper-item
.swiper-container {
    width: 100%;
    height: 100%;
}

.swiper-slide {
    // width: 320px;
    // height: 380px;
    text-align: center;
    font-size: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;

    position: relative;
}

.swiper-slide:after {
    content: '';
    position: relative;
    margin-top: 133.33%;
}

.swiper-next,
.swiper-prev {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 10;
    cursor: pointer;
    color: #333;
    width: 64px;
    height: auto;
    border-radius: 12px;
    border-radius: 0;
    will-change: transform;
    transition: all 300ms;
    outline: none;
}

.swiper-next:hover,
.swiper-prev:hover {
    width: 64px;
}

.swiper-next {
    right: -64px;
    left: auto;
    border-radius: 0;
    border-right: 0;
}

.swiper-prev {
    left: -64px;
    right: auto;
    border-radius: 0;
    border-left: 0;
}

//
//
//
a.more {
    color: #666;
    text-decoration: none;
}

// content3d-cover
.content3d-cover {
    background: rgba(127, 127, 127, 0.1);
    overflow: hidden;
}

.content3d-cover:after {
    content: '';
    position: relative;
    margin-top: 100%;
}

.content3d-cover a {
    display: block;
    width: 240px;
    height: 380px;
}

@media (max-width: 991px) {
    .content3d-title {
        padding: 0 15px;
    }

    .h1 {
        font-size: 24px;
    }

    .scroll-wrap {
        width: 100%;
        height: auto;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .scroll-wrap .b-row {
        width: 1085px;
    }

    .b-container {
        padding-left: 0;
        padding-right: 0;
    }

    .b-row {
        margin-left: 0;
        margin-right: 0;
    }

    .company-item-wrap {
        flex: 0 0 320px;
    }

    .company-item {
        width: 240px;
        height: 380px;
    }

    a.more {
        font-size: 16px;
    }

    .title {
        font-size: 16px;
    }

    .summary {
        font-size: 16px;
    }
}

.swiper-item {
    overflow: hidden;
}

.swiper-item .desc {
    will-change: transform;
    transition: all 300ms;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 80px;
    z-index: 3;
    background: rgba(255, 255, 255, 0.88);
    text-align: left;
}

.swiper-item.hover .desc {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 196px;
    z-index: 3;
    color: #fff;
    // background: linear-gradient(to bottom, rgba(255, 51, 85, 0.8) 0%, rgba(241, 53, 54, 0.9) 100%);
    background: rgba(0, 0, 0, 0.5);
}

.swiper-button-disabled img {
    opacity: 0.38;
}

.lightbox {
    display: none;
}

.lightbox.display {
    display: block;
}

.swiper-container-wrap {
    margin-left: -15px;
    margin-right: -15px;
}

@media (max-width: 991px) {
    .swiper-container-wrap {
        margin-left: 0;
        margin-right: 0;
    }
}

//
.swiper-pagination .swiper-pagination-bullet-active {
    background: #ffffff !important;
}
</style>
